const options = [
 {
    "value": "江西省",
    "label": "江西省",
    "children": [
        {
      "value": "南昌市",
      "label": "南昌市",
    }, {
      "value": "景德镇市",
      "label": "景德镇市",
    }, {
      "value": "萍乡市",
      "label": "萍乡市",
    }, {
      "value": "九江市",
      "label": "九江市",
    }, {
      "value": "新余市",
      "label": "新余市",
    }, {
      "value": "鹰潭市",
      "label": "鹰潭市",
    }, {
      "value": "赣州市",
      "label": "赣州市",
    }, {
      "value": "吉安市",
      "label": "吉安市",
    }, {
      "value": "宜春市",
      "label": "宜春市",
    }, {
      "value": "抚州市",
      "label": "抚州市",
    }, {
      "value": "上饶市",
      "label": "上饶市",
    }]
  },
]

export default options

